<template>
  <div class="thermal-electrical-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>κ / σ = L · T | 热导与电导的正比关系$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Metal Lattice -->
          <g v-for="i in 5" :key="i" :transform="`translate(${i*60}, 120)`">
             <circle r="10" fill="#444" stroke="#888" />
             <!-- Moving Electrons -->
             <circle v-for="n in 3" :key="n" r="2" fill="#ffd700">
                <animateTransform attributeName="transform" type="translate" :values="`${(n-2)*10},${(n-2)*10}; ${(n-2)*15},${(n-2)*15}; ${(n-2)*10},${(n-2)*10}`" dur="1s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Heat Gradient (Top Layer) -->
          <rect x="50" y="80" width="300" height="10" fill="url(#heat-grad)" />
          <defs>
             <linearGradient id="heat-grad">
                <stop offset="0%" stop-color="#ff4757" />
                <stop offset="100%" stop-color="#00d2ff" />
             </linearGradient>
          </defs>
          <text x="50" y="75" fill="#ff4757" font-size="8">热端 (高能电子)</text>
          <text x="320" y="75" fill="#00d2ff" font-size="8">冷端</text>

          <!-- Current flow indicator -->
          <path d="M 50,160 L 350,160" stroke="#ffd700" stroke-width="2" stroke-dasharray="10, 5">
             <animate attributeName="stroke-dashoffset" from="100" to="0" dur="2s" repeatCount="indefinite" />
          </path>
          <text x="170" y="175" fill="#ffd700" font-size="8">自由电子输运电荷与能量</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>劳伦兹数 L: 2.44 × 10⁻⁸ W·Ω·K⁻² (常规金属)</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>在典型的金属中，热量和电流主要是由同一批载流子——**自由电子**来搬运的。因此，金属的**热导率 (κ)** 与 **电导率 (σ)** 之间存在着密切的正比关系，且比例随绝对温度 T 变化。这解释了为什么电的良导体（如银、铜、金）通常也是热的良导体，以及为什么石墨或钻石这种非金属即使不导电也能有很好的热导（靠声子）。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'ThermalElectricalCondViz'
}
</script>

<style scoped lang="scss">
.thermal-electrical-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
